import { useCallback, useEffect, useRef } from "react";
import useServiceStatus from "../useServiceStatus";
import { useDispatch, useSelector } from "react-redux";
import {
  getLiveSuggestion,
  liveSuggestionFor,
  normalizeLiveTimeframe,
} from "../../redux/live-suggestion/liveSuggestionSlice";

function useFetchLiveSignal({ coins = [], availableExchanges }) {
  const {
    main: { userData },
    liveSuggestion: { suggestions, liveTimeframe, refreshTick },
  } = useSelector((state) => state);

  const { isActive: isInsightActive } = useServiceStatus("insight");
  const { isActive: isAiActive } = useServiceStatus("aiAssistant");
  const seenFrame = useRef(null);
  const seenTick = useRef(null);

  const dispatch = useDispatch();

  const fetchLiveSignals = useCallback(() => {
    if (coins.length === 0) return;

    const timeframe = normalizeLiveTimeframe(liveTimeframe);
    coins.forEach((coin) => {
      const coinSuggestion = liveSuggestionFor(suggestions, coin, timeframe);
      if (coinSuggestion) {
        // const now = moment();
        // const signalTime = moment.utc(coinSuggestion.signal_timestamp).local();
        // const diffInMinutes = now.diff(signalTime, "minutes");
        // if (diffInMinutes < 15) return;
        return;
      }

      dispatch(
        getLiveSuggestion(
          userData["custom:custom_username"],
          userData["cognito:username"],
          availableExchanges?.[0] || "kucoin",
          coin,
          false,
          null,
          false,
          false,
          0,
          [],
          timeframe,
        ),
      );
    });
  }, [availableExchanges, coins, dispatch, liveTimeframe, suggestions, userData]);

  useEffect(() => {
    const frame = normalizeLiveTimeframe(liveTimeframe);
    const timeframeChanged = seenFrame.current !== null && seenFrame.current !== frame;
    const refreshRequested = seenTick.current !== null && seenTick.current !== refreshTick;
    seenFrame.current = frame;
    seenTick.current = refreshTick;
    if (!timeframeChanged && !refreshRequested) return;
    if (
      userData?.["custom:custom_username"] &&
      (isInsightActive || isAiActive)
    ) {
      fetchLiveSignals();
    }
  }, [fetchLiveSignals, isInsightActive, isAiActive, liveTimeframe, refreshTick, userData]);

  return null;
}

export default useFetchLiveSignal;
